import React from 'react';
export function TopBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-ink/95 backdrop-blur" data-id="element-226" data-mp="3sdww54cn05jm">
      <div className="mx-auto flex h-14 w-full max-w-6xl items-center justify-center px-5 sm:px-8" data-id="element-227" data-mp="231c4m24ntjyd">
        <a href="#top" className="flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-tight text-white sm:text-base" data-id="element-228" data-mp="1y4c4e7uhrbf6">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-cheer text-[11px] font-black text-white" data-id="element-229" data-mp="2qrg6a3yaf9mq">
            CR
          </span>
          Cheerleading Ready <span className="text-cheer" data-id="element-230" data-mp="2h24xyjj868zw">360</span>
        </a>
      </div>
    </div>;
}